export const useFilePicker = () => {
  const pickFile = async (callbackFn) => {
    if (!callbackFn) {
      throw new Error('Callback function is required for pickFile!');
    }
    // show picker to select file; Expo Documentpicker does not respect "copyToCacheDirectory: false" for web
    // so we use a simple input element (what expo documentpicker also does under the hood)

    // create input element to trigger file picker
    const input = document.createElement('input');
    input.style.display = 'none';
    input.setAttribute('type', 'file');
    input.setAttribute('accept', '*'); // comma seperated list of mime types
    input.setAttribute('id', String(10 * Math.random()));
    // input.setAttribute('multiple', 'multiple');
    document.body.appendChild(input);

    // define event listener for file selection
    input.addEventListener('change', (e) => {
      callbackFn(e.target.files[0]);
      document.body.removeChild(input);
    });

    input.addEventListener('cancel', () => {
      document.body.removeChild(input);
    });

    // trigger click event for hidden file picker
    const event = new MouseEvent('click');
    input.dispatchEvent(event);
  };

  return {
    pickFile,
  };
};
